import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {environment} from '../../../../../../environments/environment';
import {CheckStampService} from '../services/check-stamp.service';
import {AgencyService} from '../../../qrcode/agencyListing/services/agency.service';
import {ToastrService} from 'ngx-toastr';
import {EvsAddressService} from '../../../../../common/services/EvsAddress.service';
import {BatchstampService} from '../../../qrcode/batchstamp/batchstamp.service';
import {WarningInspection} from '../../../qrcode/warning-overflow/services/warning-inspection';
import {Subject} from 'rxjs/Subject';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs/Subscription';

declare var $: any;

@Component({
  selector: 'app-stamp-box',
  templateUrl: './stamp-box.component.html',
  styleUrls: ['./stamp-box.component.css'],
  providers: [CheckStampService, AgencyService, WarningInspection],
})
export class StampBoxComponent implements OnInit {
  loading_page = false;
  has_data = true;
  data;
  // loại tem : true là nhà sản xuất, fale là nhà được phân phối
  type_stamp = true;
  // trang thai cua loại tem nha sản xuất: 0: chưa phân phối, 1 đã phân phối
  status_stamp = 0;
  // trang thai cua loại tem nhà phân phối :  0 : chưa xác nhận, 1: đã xác nhận nhưng chưa đủ, 2: đã xác nhận đủ
  status_stamp2 = 0;
  // ================= chi tiet tem trong thung ====================== //
  queryStampOfBox;
  data_stamp_of_box = [];
  total_stamp_of_box = 0;
  pageIndexStampOfBox = 1;
  pageSizeStampOfBox = 10;
  static;
  // ================= end chi tiet tem trong thung ================== //

  // ==================== lich su phan phoi ================ //
  pageIndexDistribution = 1;
  pageSizeDistribution = 10;
  bodyDistribution;
  data_distribution = [];
  total_distribution = 0;
  // ==================== end  lich su phan phoi ================ //

  // ==================== ds canh bao thi truong =========== //
  pageIndexWarning = 1;
  pageSizeWarning = 10;
  queryWarning;
  data_warning = [];
  total_warning = 0;
  // ==================== end ds canh bao thi truong ======== //

  /// ==================== lich su quet ======================= //
  queryScan;
  pageIndexScan = 1;
  pageSizeScan = 10;
  data_scan = [];
  total_scan = 0;

  // ==================== end lich su quet =================== //

  // tao moi canh bao thi truong
  valid_agency = false;
  warning_count = 0;
  note_warning = "";
  agency_detail;
  body: any;
  disable_warning = false;
  cities = [];
  districts = [];
  validProvinceId = false;
  validDistrict = false;
  address = "";
  // end canh bao thi truong
  // ============ trả hàng  ================= //
  note_return = "";
  valid_note_return = false;
  data_return: any;
  type_return: number;
  valid_stamp_select = false;
  disable_return = false;
  is_separation = false;
  // ============ end  trả hàng ================= //

  // =========== xoa tem khoi thung ============ //
  isCheckAll = false;
  listOfChecked = {};
  list_id = [];
  type: string;
  data_remove = [];
  disable_remove = false;
  data_checked = [];
  // =========== end xoa tem ================ //

  // ============ thu hoi tem ================ //
  disable_revoke = false;
  // ============ end  thu hoi tem ================ //
  form = this.fb.group({
    code: "",
  });
  listBatches = [];
  totalBatchPage = 10;
  batchCurrentPage = 1;
  message = "Không tìm thấy thông tin tem";
  has_baohanh = true;
  logsScanGuarantee = [];
  logs_BH = {
    currentPage: 1,
    has_list: [],
  };
  listDistribution = [];
  lat = 21.053751;
  lng = 105.739419;

  public dirs: Array<any> = [
    {
      origin: { lat: 21.05133, lng: 105.734137 },
      destination: { lat: 21.055237, lng: 105.735958 },
      renderOptions: { polylineOptions: { strokeColor: "red" } },
    },
  ];
  data_map = [];
  data_map_warning = [];
  zoom = 15;
  activeTab = 1;
  status_distribution = [
    {
      label: "Chưa phân phối",
      value: 0,
    },
    {
      label: "Đã phân phối",
      value: 1,
    },
    {
      label: "Đang phân phối",
      value: 2,
    },
  ];
  status_confirm = [
    {
      label: "Đã xác nhận",
      value: 1,
    },
    {
      label: "Chưa xác nhận",
      value: 0,
    },
  ];
  isDistribution: Boolean = false;
  isList: Boolean = true;
  load_map_distrivution = true;
  @ViewChild("checkWarning") checkWarning: ModalDirective;
  @ViewChild("retutn") retutn: ModalDirective;
  @ViewChild("blockModal") blockModal: ModalDirective;
  @ViewChild("remove") remove: ModalDirective;
  @ViewChild("revoke") revoke: ModalDirective;
  @ViewChild("boxStampDistribution") boxStampDistribution;

  // block tem
  note_block: string;
  disable_block = false;

  // end block tem

  // chi tiet trang thai tach le 1 dai tem thung
  type_status: string;
  data_detail: any;

  // end
  after_create_warning = false;

  unsubscribe$ = new Subject<void>();
  langChangeSub: Subscription;

  constructor(
    private fb: FormBuilder,
    private checkStampService: CheckStampService,
    private agencyService: AgencyService,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    private batchService: BatchstampService,
    private warningInspection: WarningInspection,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.isDistribution = false;
    this.isList = true;

    const reinitSelect2 = (selector: string, config: any, keepValue = true) => {
      const $el = $(selector);
      if (!$el || !$el.length) return;
      const currentVal = keepValue ? $el.val() : null;
      if ($el.data('select2')) {
        $el.select2('destroy');
      }
      $el.select2(config);
      if (keepValue && currentVal != null) {
        $el.val(currentVal).trigger('change');
      }
    };

    $("#box_stamp_lot").select2({
      placeholder: this.translate.instant('LO_TEM'),
      allowClear: true,
      minimumInputLength: 3,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches?show_parent_child=true`,
        headers: {
          authorization: localStorage.getItem("Access-Token"),
          "Content-Type": "application/json",
        },
        dataType: "json",
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.batches.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    $("#box_product").select2({
      placeholder: "Sản phẩm",
      allowClear: true,
      minimumInputLength: 3,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/products`,
        headers: {
          authorization: localStorage.getItem("Access-Token"),
          "Content-Type": "application/json",
        },
        dataType: "json",
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.products.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    $("#status_stamp").select2({
      placeholder: this.translate.instant('TRANG_THAI_TEM'),
      allowClear: true,
    });
    $("#status_confirm").select2({
      placeholder: this.translate.instant('TRANG_THAI_XAC_NHAN_CUA_DAI_LY'),
      allowClear: true,
    });
    $("#status_distribution").select2({
      placeholder: this.translate.instant('TRANG_THAI_PHAN_PHOI'),
      allowClear: true,
    });
    $("#actions").select2({ placeholder: this.translate.instant('CHON_HANH_DONG'), allowClear: true });
    $("#box_stamp_lot2").select2({
      placeholder: this.translate.instant('LO_TEM'),
      allowClear: true,
      minimumInputLength: 3,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches?show_parent_child=true`,
        headers: {
          authorization: localStorage.getItem("Access-Token"),
          "Content-Type": "application/json",
        },
        dataType: "json",
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.batches.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    $("#box_product2").select2({
      placeholder: this.translate.instant('SAN_PHAM'),
      allowClear: true,
      minimumInputLength: 3,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/products`,
        headers: {
          authorization: localStorage.getItem("Access-Token"),
          "Content-Type": "application/json",
        },
        dataType: "json",
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.products.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    $("#status_confirm2").select2({
      placeholder: this.translate.instant('TRANG_THAI_XAC_NHAN_CUA_DAI_LY'),
      allowClear: true,
    });
    $("#actions2").select2({ placeholder: this.translate.instant('CHON_HANH_DONG'), allowClear: true });
    $("#Agency2").select2({
      placeholder: this.translate.instant('CHON_DAI_LY_PHAN_PHOI'),
      allowClear: true,
    });
    $("#cities").select2({ placeholder: this.translate.instant('TINH_THANH'), allowClear: true });
    $("#district").select2({ placeholder: this.translate.instant('QUAN_HUYEN'), allowClear: true });
    $("#ward").select2({ placeholder: this.translate.instant('PHUONG_XA'), allowClear: true });

    const agency = $("#agencyBox");
    agency.select2({
      placeholder: this.translate.instant('CHON_DAI_LY_CANH_BAO'),
      allowClear: false,
      minimumInputLength: 3,
      ajax: {
        delay: 1000,
        url: `${environment.qrcode_url}/agencies`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Access-Token")}`,
          "Content-Type": "application/json",
        },
        dataType: "json",
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.items.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    const that = this;
    agency.on("select2:open", function () {
      that.valid_agency = false;
    });
    agency.on("select2:close", function () {
      const val = agency.val();
      if (!val) {
        that.valid_agency = true;
        return;
      }
      that
        .getTotalWarning(val)
        .then((res) => {
          if (res.code === 1) {
            that.warning_count = res.data;
            return;
          }
          that.warning_count = 0;
        })
        .catch((err) => {
          that.warning_count = 0;
        });
      that.getDetilAgency(val).then((res) => {
        if (res.code === 1) {
          that.agency_detail = res.data;
        }
      });
    });
    this.getFromArea();
    const cities = $("#citiesBox");
    cities.select2({ placeholder: this.translate.instant('TINH_THANH'), allowClear: false });
    cities.on("select2:select", function (e) {
      $(".select2-selection__rendered").removeAttr("title");
      $("#districtBox").val(null).trigger("change");
      const id = e.target.value;
      that.getDistrict(id);
    });
    cities.on("select2:open", function () {
      that.validProvinceId = false;
    });
    cities.on("select2:close", function (e) {
      const id = e.target.value;
      if (!id) {
        that.validProvinceId = true;
      }
    });
    const district = $("#districtBox");
    district.select2({ placeholder: this.translate.instant('QUAN_HUYEN'), allowClear: false });
    district.on("select2:open", function () {
      that.validDistrict = false;
    });
    district.on("select2:close", function (e) {
      const id = e.target.value;
      if (!id) {
        that.validDistrict = true;
      }
    });
    $("#note_return").on("change keyup paste", function () {
      that.valid_note_return = false;
      if (!this.value) {
        that.valid_note_return = true;
      }
    });

    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      reinitSelect2('#actions', { placeholder: this.translate.instant('CHON_HANH_DONG'), allowClear: true });
      reinitSelect2('#actions2', { placeholder: this.translate.instant('CHON_HANH_DONG'), allowClear: true });

      reinitSelect2('#status_stamp', { placeholder: this.translate.instant('TRANG_THAI_TEM'), allowClear: true });
      reinitSelect2('#status_confirm', { placeholder: this.translate.instant('TRANG_THAI_XAC_NHAN_CUA_DAI_LY'), allowClear: true });
      reinitSelect2('#status_distribution', { placeholder: this.translate.instant('TRANG_THAI_PHAN_PHOI'), allowClear: true });
      reinitSelect2('#status_confirm2', { placeholder: this.translate.instant('TRANG_THAI_XAC_NHAN_CUA_DAI_LY'), allowClear: true });

      reinitSelect2('#cities', { placeholder: this.translate.instant('TINH_THANH'), allowClear: true });
      reinitSelect2('#district', { placeholder: this.translate.instant('QUAN_HUYEN'), allowClear: true });
      reinitSelect2('#ward', { placeholder: this.translate.instant('PHUONG_XA'), allowClear: true });

      reinitSelect2('#agencyBox', { placeholder: this.translate.instant('CHON_DAI_LY_CANH_BAO'), allowClear: false, minimumInputLength: 3, ajax: agency.select2('options').options.ajax });
      reinitSelect2('#citiesBox', { placeholder: this.translate.instant('TINH_THANH'), allowClear: false });
      reinitSelect2('#districtBox', { placeholder: this.translate.instant('QUAN_HUYEN'), allowClear: false });

      // ajax selects
      reinitSelect2('#box_stamp_lot', { placeholder: this.translate.instant('LO_TEM'), allowClear: true, minimumInputLength: 3, ajax: $("#box_stamp_lot").select2('options').options.ajax });
      reinitSelect2('#box_stamp_lot2', { placeholder: this.translate.instant('LO_TEM'), allowClear: true, minimumInputLength: 3, ajax: $("#box_stamp_lot2").select2('options').options.ajax });
      reinitSelect2('#box_product2', { placeholder: this.translate.instant('SAN_PHAM'), allowClear: true, minimumInputLength: 3, ajax: $("#box_product2").select2('options').options.ajax });
    });
  }

  ngOnDestroy() {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  loadData(data) {

    this.data_map = [];
    this.data_map_warning = [];
    this.valid_stamp_select = false;
    this.after_create_warning = false;
    this.load_map_distrivution = true;
    this.data = data;
    console.log(this.data);
    let serial = this.data.serial;
    serial = serial.split("-");
    const id = serial[serial.length - 1];
    const format = "000000";
    serial[serial.length - 1] =
      format.substring(0, format.length - id.toString().length) + id;

    this.data.serial_convetd = serial.join("-");
    // this.data.serial_convetd =
    //   serial[0] +
    //   "-" +
    //   format.substring(0, format.length - id.toString().length) +
    //   id;
    const idStart = this.data.idStart;
    this.data.idStart =
      format.substring(0, format.length - idStart.toString().length) + idStart;
    console.log(this.data);
    // owner = true: sản xuất, = false : phân phối
    this.type_stamp = data.owner;
    if (data.bundleId !== null) {
      // this.loadStampOfBox();
      this.resetStampOfBox();
      this.getStaticStampOfBox(this.data.serial_convetd);
    } else {
      this.total_stamp_of_box = 0;
      this.data_stamp_of_box = [];
    }
    this.loadHistoryDistribution();

    this.loadListWarning();
    this.loadHistoryScan();
    setTimeout(() => {
      this.getAllWarningMarket();
    }, 2000);
  }

  // =========== thông kê tem trong chi tiết tem =========== //
  getStaticStampOfBox(serial?: any) {
    let query: any = {
      stamp: serial,
    };
    this.checkStampService
      .getStaticStampOfBox(this.data.bundleId, query)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.static = res.data;
            return;
          }
          this.static = undefined;
        },
        (error) => {
          this.static = undefined;
        }
      );
  }

  // =========== end thông kê tem trong chi tiết tem =========== //
  showActionCol: boolean = true;
  // danh sach tem trong thung
  loadStampOfBox(e?) {
    console.log('e', e);
    if(e){
      this.data.boxNote = e;
    }
    if (this.data.owner === true) {
      this.queryStampOfBox = {
        code: $("#code").val() || "",
        lotId: $("#box_stamp_lot").val() || "",
        productId: $("#box_product").val() || "",
        status: "",
        agencyStatus: "",
        page: this.pageIndexStampOfBox,
        page_size: this.pageSizeStampOfBox,
        stamp: this.data.serial_convetd,
      };
      if (this.data.distributeStatus !== 1) {
        this.queryStampOfBox.status = $("#status_distribution").val() || "";
      }
      if (this.data.distributeStatus === 1) {
        this.queryStampOfBox.agencyStatus = $("#status_confirm").val() || "";
      }
    }
    if (this.data.owner === false) {
      this.queryStampOfBox = {
        code: $("#code2").val() || "",
        lotId: $("#box_stamp_lot2").val() || "",
        productId: $("#box_product2").val() || "",
        status: "",
        agencyStatus: $("#status_confirm2").val() || "",
        page: this.pageIndexStampOfBox,
        page_size: this.pageSizeStampOfBox,
        stamp: this.data.serial_convetd,
      };
    }

    this.checkStampService
      .getStampOfBox(this.data.bundleId, this.queryStampOfBox)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.total_stamp_of_box = res.data.totalElement;
            this.data_stamp_of_box = res.data.items;
            this.showActionCol = this.data_stamp_of_box.every(
              (gg) => gg.status !== 0 && gg.status !== 1
            );
            console.log(this.showActionCol);

            this.data_stamp_of_box.map((i) => {
              const pad = "000000";
              i.idEnd =
                pad.substring(0, pad.length - i.idEnd.toString().length) +
                i.idEnd;
              i.idStart =
                pad.substring(0, pad.length - i.idStart.toString().length) +
                i.idStart;
            });

            this.refeshCheckAll();
            return;
          }
          this.total_stamp_of_box = 0;
          this.data_stamp_of_box = [];
        },
        (error) => {
          this.total_stamp_of_box = 0;
          this.data_stamp_of_box = [];
        }
      );
  }

  searchStampOfBox() {
    this.pageIndexStampOfBox = 1;
    this.loadStampOfBox();
  }

  resetStampOfBox() {
    $("#code").val(null).trigger("change");
    $("#box_stamp_lot").empty().trigger("change");
    $("#box_product").empty().trigger("change");
    $("#status_distribution").val(null).trigger("change");
    $("#status_confirm").val(null).trigger("change");
    $("#code2").val(null).trigger("change");
    $("#box_stamp_lot2").empty().trigger("change");
    $("#box_product2").empty().trigger("change");
    $("#status_confirm2").val(null).trigger("change");
    this.pageIndexStampOfBox = 1;
    this.loadStampOfBox();
  }

  prePageStampOfBox() {
    if (this.pageIndexStampOfBox > 1) {
      this.pageIndexStampOfBox = this.pageIndexStampOfBox - 1;
      this.loadStampOfBox();
    }
  }

  inputPageStampOfBoxChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexStampOfBox) {
      this.pageIndexStampOfBox = page;
      this.loadStampOfBox();
    }
  }

  lastPageStampOfBox() {
    if (
      this.pageIndexStampOfBox * this.pageSizeStampOfBox <
      this.total_stamp_of_box
    ) {
      this.pageIndexStampOfBox = this.pageIndexStampOfBox + 1;
      this.loadStampOfBox();
    }
  }

  // end danh sach tem trong thung

  // =============== lich su phan phoi ================= //
  loadHistoryDistribution() {
    this.bodyDistribution = {
      serial: this.data.serial,
      page: this.pageIndexDistribution,
      page_size: this.pageSizeDistribution,
      owner: this.data.owner,
    };
    this.checkStampService.getStampHistory(this.bodyDistribution).subscribe(
      async (res) => {
        if (res.code === 1) {
          this.data_distribution = res.data.items;
          this.data_distribution.map((item) => {
            const arrLocation = [];
            const arr_keys = ['fromProvince', 'fromDistrict', 'fromAddress'];
            arr_keys.map((key) => {
              if (item[key] === null) {
                item[key] = 'Không xác định';
              }
            });
            item.toLocationData.map((val) => {
              const address = val.toAddress ? val.toAddress + ' - ' : '';
              const toDistrictArea = val.toDistrictArea ? val.toDistrictArea : '';
              const toProvincesArea = val.toProvincesArea ? val.toProvincesArea : '';
              const result = address + toDistrictArea + ' - ' + toProvincesArea;
              arrLocation.push(result);
              item.toLocationDataConvert = arrLocation;
            })
            if (item.toAgency === null) {
              item.toAgency = 'Khu vực';
              const list_province_Id = item.location.item.provinceIds;
              const list_province_name = [];
              this.cities.map((city) => {
                if (list_province_Id.includes(city.id)) {
                  list_province_name.push(city.value);
                }
              });
              item.to_list_provinceName = 'Không xác định';
              item.to_list_districtName = "Không xác định";
              item.to_list_address = "Không xác định";
              if (item.to_list_provinceName.length > 0) {
                item.to_list_provinceName = list_province_name.toString();
              }

              if (list_province_Id.length === 1) {
                const list_district_Id = item.location.item.districtIds;
                const list_district_name = [];
                this.getDistrictMap(list_province_Id[0]).then((districts) => {
                  if (districts.error === false) {
                    const data_districts = districts.data.districts;
                    data_districts.map((one_district) => {
                      if (list_district_Id.includes(one_district.id)) {
                        list_district_name.push(one_district.name);
                      }
                    });
                    if (list_district_name.length > 0) {
                      item.to_list_districtName = list_district_name.toString();
                    }
                  }
                });
                if (list_district_Id.length === 1) {
                  item.to_list_address = item.location.item.address[0];
                }
              }
              return;
            }
            const keys = ["toProvince", "toDistrict", "toAddress"];
            keys.map((key) => {
              if (item[key] === null) {
                item[key] = "Không xác định";
              }
            });
          });
          this.total_distribution = res.data.totalElement;
          if (res.data.totalElement && this.load_map_distrivution === true) {
            this.getAllHistoryDistribution();
          }
          return;
        }
        this.data_distribution = [];
        this.total_distribution = 0;
      },
      (error) => {
        this.data_distribution = [];
        this.total_distribution = 0;
      }
    );
  }

  prePageHistoryDistribution() {
    if (this.pageIndexDistribution > 1) {
      this.pageIndexDistribution = this.pageIndexDistribution - 1;
      this.load_map_distrivution = false;
      this.loadHistoryDistribution();
    }
  }

  inputPageHistoryDistributionChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexDistribution) {
      this.pageIndexDistribution = page;
      this.load_map_distrivution = false;
      this.loadHistoryDistribution();
    }
  }

  lastPageHistoryDistribution() {
    if (
      this.pageIndexDistribution * this.pageSizeDistribution <
      this.total_distribution
    ) {
      this.pageIndexDistribution = this.pageIndexDistribution + 1;
      this.load_map_distrivution = false;
      this.loadHistoryDistribution();
    }
  }

  // =============== end lich su phan phoi ================= //

  // =============== ds cnah bao tu kiem tra thi truong =============== //
  loadListWarning() {
    this.queryWarning = {
      serial: this.data.serial,
      agencyId: "",
      provinceId: "",
      districtId: "",
      wardId: "",
      from: "",
      to: "",
      page: this.pageIndexWarning,
      page_size: this.pageSizeWarning,
    };
    this.checkStampService.getWarningMarket(this.queryWarning).subscribe(
      (res) => {
        if (res.code === 1) {
          this.data_warning = res.data.items;
          this.total_warning = res.data.totalElement;
          return;
        }
        this.data_warning = [];
        this.total_warning = 0;
      },
      (error) => {
        this.data_warning = [];
        this.total_warning = 0;
      }
    );
  }

  prePageWarning() {
    if (this.pageIndexWarning > 1) {
      this.pageIndexWarning = this.pageIndexWarning - 1;
      this.loadListWarning();
    }
  }

  inputPageWarningChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexWarning) {
      this.pageIndexWarning = page;
      this.loadListWarning();
    }
  }

  lastPageWarning() {
    if (this.pageIndexWarning * this.pageSizeWarning < this.total_warning) {
      this.pageIndexWarning = this.pageIndexWarning + 1;
      this.loadListWarning();
    }
  }

  // =============== end ds canh bao ====================== //

  // =============== lich su quet =================== //

  loadHistoryScan() {
    this.queryScan = {
      page: this.pageIndexScan,
      page_size: this.pageSizeScan,
      box_id: this.data.boxId,
      serial: this.data.serial,
      owner: this.data.owner,
    };
    this.checkStampService.getHistoryScanStampBox(this.queryScan).subscribe(
      (res) => {
        if (res.code === 1) {
          this.data_scan = res.data.items;
          this.total_scan = res.data.totalElement;
          return;
        }
        this.data_scan = [];
        this.total_scan = 0;
      },
      (error) => {
        this.data_scan = [];
        this.total_scan = 0;
      }
    );
  }

  prePageHistoryScan() {
    if (this.pageIndexScan > 1) {
      this.pageIndexScan = this.pageIndexScan - 1;
      this.loadHistoryScan();
    }
  }

  inputPageHistoryScanChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexScan) {
      this.pageIndexScan = page;
      this.loadHistoryScan();
    }
  }

  lastPageHistoryScan() {
    if (this.pageIndexScan * this.pageSizeScan < this.total_scan) {
      this.pageIndexScan = this.pageIndexScan + 1;
      this.loadHistoryScan();
    }
  }

  // =============== end lich su quet ================ //

  onMouseOver(infoWindow, gm) {
    if (gm.lastOpen != null) {
      gm.lastOpen.close();
    }

    gm.lastOpen = infoWindow;

    infoWindow.open();
  }

  onMouseOut(infoWindow, gm) {
    infoWindow.close();
  }

  moveToMap() {
    $("html, body").animate({ scrollTop: 1300 }, 500);
  }

  changeTab(event) {
    this.activeTab = event;
    this.resetModalWarning();
  }

  getTotalWarning(agencyId?: string) {
    return this.checkStampService.getTotalWarning(agencyId).toPromise();
  }

  getDetilAgency(id?: string) {
    return this.agencyService.getDetail(id).toPromise();
  }

  submitModalWarning() {
    const val = $("#agencyBox").val();
    if (this.activeTab === 1) {
      if (!val) {
        this.valid_agency = true;
        return;
      }
      const body = {
        type: 0,
        // tslint:disable-next-line:radix
        provinceWarningId: parseInt(this.agency_detail.provinceId),
        // tslint:disable-next-line:radix
        districtWarningId: parseInt(this.agency_detail.districtId),
        wardWarningId: null,
        addressWarning: this.agency_detail.address,
        note: this.note_warning,
        // tslint:disable-next-line:radix
        agencyWarningId: parseInt(val),
        stampCode: this.data.serial,
        bundleType: 1,
      };
      this.body = body;
    }
    if (this.activeTab === 2) {
      const provinceId = $("#citiesBox").val();
      const districtId = $("#districtBox").val();
      if (!provinceId) {
        this.validProvinceId = true;
      }
      if (!districtId) {
        this.validDistrict = true;
      }
      if (!provinceId || !districtId) {
        return;
      }
      const body = {
        type: 1,
        // tslint:disable-next-line:radix
        provinceWarningId: parseInt(provinceId),
        // tslint:disable-next-line:radix
        districtWarningId: parseInt(districtId),
        wardWarningId: null,
        addressWarning: this.address,
        note: this.note_warning,
        bundleId: this.data.bundleId,
        // tslint:disable-next-line:radix
        agencyWarningId: null,
        stampCode: this.data.serial,
        bundleType: this.data.bundleType,

      };
      this.body = body;
    }
    this.disable_warning = true;
    this.checkStampService.createWarning(this.body).subscribe(
      (res) => {
        this.disable_warning = false;
        if (res.code === 1) {
          this.toastr.success("Tạo mới cảnh báo thành công", "Thành công", {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
          this.loadListWarning();
          this.after_create_warning = true;
          this.getAllWarningMarket();
          this.checkWarning.hide();
          this.resetModalWarning();
          return;
        }
        this.toastr.error(res.message, "Tạo mới cảnh báo thất bại", {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
      },
      (error) => {
        this.disable_warning = false;
        this.toastr.error(error.message, "Tạo mới cảnh báo thất bại", {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
      }
    );
  }

  showModalWarning() {
    this.activeTab = 1;
    this.resetModalWarning();
    this.checkWarning.show();
  }

  closeModalWarning() {
    this.resetModalWarning();
    this.activeTab = 1;
    this.checkWarning.hide();
  }

  resetModalWarning() {
    this.valid_agency = false;
    this.warning_count = 0;
    this.warning_count = 0;
    this.note_warning = undefined;
    this.validDistrict = false;
    this.validProvinceId = false;
    this.address = undefined;
    $("#agencyBox").val(null).trigger("change");
    $("#citiesBox").val(null).trigger("change");
    $("#districtBox").val(null).trigger("change");
  }

  getFromArea() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  getDistrict(id: number) {
    const query = {
      city_id: id,
    };
    this.addressService.getDistrict(query).subscribe(
      (res) => {
        if (res.status === 200) {
          const citiesList = [];
          const items = res.data.districts;
          items.map((item) => {
            citiesList.push({
              label: item.name,
              id: item.id,
            });
          });
          this.districts = citiesList;

          return;
        }
        this.districts = [];
      },
      (error) => {
        this.districts = [];
      }
    );
  }

  // ============== trả hàng ================== //
  openModalReturn(type?: number, data?: any) {
    this.valid_note_return = false;
    this.type_return = type;
    this.disable_return = false;
    // type = 1 : tra theo thung
    if (type === 1) {
      this.data_return = this.data;
    }
    // type - 2: tra theo 1 list id
    if (type === 2) {
      this.data_return = undefined;
    }
    if (type === 3) {
      $("#type3_start").val(data.idStart);
      $("#type3_end").val(data.idEnd);
      this.data_return = data;
    }
    this.note_return = "";
    this.retutn.show();
  }

  closeModalReturn() {
    this.retutn.hide();
  }

  submitModalReturn() {
    this.valid_note_return = false;
    if (!this.note_return) {
      this.valid_note_return = true;
      return;
    }
    this.disable_return = true;
    if (this.type_return === 1) {
      let serial = this.data_return.serial;
      serial = serial.split("-");
      this.disable_block = true;
      let id = serial[1];
      id = id.split("");
      let index = 0;
      for (let i = 0; i < id.length; i++) {
        // tslint:disable-next-line:radix
        if (parseInt(id[i]) !== 0) {
          index = id.indexOf(id[i]);
          break;
        }
      }
      const id_start = this.data_return.idStart;
      const body = {
        listData: [
          {
            type: this.type_return === 1 ? 1 : 0,
            prefix: this.data_return.prefix,
            idStart: id_start,
            idEnd: id_start,
            note: this.note_return,
          },
        ],
      };
      this.checkStampService
        .createReturnStamp(body)
        .takeUntil(this.unsubscribe$)
        .subscribe(
          (res) => {
            this.disable_return = false;
            if (res.code === 1) {
              this.toastr.success(
                "Tạo mới yêu cầu trả tem thành công" +
                  `<div>Thành công: <b>${res.data.success}</b>, Thất bại: <b>${res.data.fail}</b></div>`,
                "Thành công",
                {
                  timeOut: 4000,
                  positionClass: "toast-top-right",
                  enableHtml: true,
                }
              );
              this.loadStampOfBox();
              this.closeModalReturn();
              return;
            }
            this.toastr.error(res.message, "Thất bại");
          },
          (error) => {
            this.disable_return = false;
            this.toastr.error(error.message, "Thất bại");
          }
        );
      return;
    }
    if (this.type_return === 2) {
      const data = [];
      this.data_checked.map((item) => {
        const object = {
          type: item.bundleType,
          prefix: item.prefix,
          idStart: item.idStart,
          idEnd: item.idEnd,
          note: this.note_return,
        };
        data.push(object);
      });

      const body = {
        listData: data,
      };
      this.checkStampService
        .createReturnStamp(body)
        .takeUntil(this.unsubscribe$)
        .subscribe(
          (res) => {
            this.disable_return = false;
            if (res.code === 1) {
              this.data_checked = [];
              this.listOfChecked = {};
              this.toastr.success(
                "Tạo mới yêu cầu trả tem thành công" +
                  `<div>Thành công: <b>${res.data.success}</b>, Thất bại: <b>${res.data.fail}</b></div>`,
                "Thành công",
                {
                  timeOut: 4000,
                  positionClass: "toast-top-right",
                  enableHtml: true,
                }
              );
              this.loadStampOfBox();
              this.closeModalReturn();
              return;
            }
            this.toastr.error(res.message, "Thất bại");
          },
          (error) => {
            this.disable_return = false;
            this.toastr.error(error.message, "Thất bại");
          }
        );
    }
    if (this.type_return === 3) {
      const id_start = $("#type3_start").val();
      const id_end = $("#type3_end").val();
      // tslint:disable-next-line:radix
      if (parseInt(id_start) > parseInt(id_end)) {
        this.toastr.error("Serial không hợp lệ", "Có lỗi xảy ra");
        this.disable_return = false;
        return;
      }
      // const list_stamp = [];
      // for (let i = id_start; i <= id_end; i ++) {
      //   list_stamp.push(i.toString());
      // }
      // const list_separation = this.data_return.children;
      // this.is_separation = false;
      // list_separation.map(item => {
      //   const idStart = item.idStart;
      //   const idEnd = item.idEnd;
      //   for (let i = idStart; i <= idEnd; i ++) {
      //     if (list_stamp.includes(i.toString())) {
      //       this.is_separation = true;
      //       break;
      //     }
      //   }
      // })
      // if (this.is_separation) {
      //   this.toastr.error(
      //     'Serial đã bị tách phân phối lẻ',
      //     'Có lỗi xảy ra'
      //   )
      //   this.disable_return = false;
      //   return;
      // }
      const body = {
        listData: [
          {
            type: 0,
            prefix: this.data_return.prefix,
            idStart: id_start,
            idEnd: id_end,
            note: this.note_return,
          },
        ],
      };
      this.checkStampService
        .createReturnStamp(body)
        .takeUntil(this.unsubscribe$)
        .subscribe(
          (res) => {
            this.disable_return = false;
            if (res.code === 1) {
              this.toastr.success(
                "Tạo mới yêu cầu trả tem thành công",
                "Thành công",
                {
                  timeOut: 4000,
                  positionClass: "toast-top-right",
                }
              );
              this.loadStampOfBox();
              this.closeModalReturn();
              return;
            }
            this.toastr.error(res.message, "Thất bại");
          },
          (error) => {
            this.disable_return = false;
            this.toastr.error(error.message, "Thất bại");
          }
        );
      return;
    }
  }

  // ============= end tra hang ================ //

  // khoa tem
  openModalBlock() {
    this.note_block = undefined;
    this.disable_block = false;
    this.blockModal.show();
  }

  submitModalBlock() {
    if (!this.note_block) {
      this.toastr.error("Chưa nhập lý do khóa", "Có lỗi xảy ra");
      return;
    }
    const batch_id = this.data.batchId;
    let serial = this.data.serial;
    serial = serial.split("-");
    this.disable_block = true;
    let id = serial[1];
    id = id.split("");
    let index = 0;
    for (let i = 0; i < id.length; i++) {
      // tslint:disable-next-line:radix
      if (parseInt(id[i]) !== 0) {
        index = id.indexOf(id[i]);
        break;
      }
    }
    // const id_start = serial[1].slice(index);
    const id_start = this.data.idStart;
    const body = {
      batch_id: batch_id,
      id_start: id_start,
      id_end: id_start,
      note: this.note_block.trim(),
      status: 1,
    };
    this.batchService.restoreStamp(body).subscribe(
      (res) => {
        this.disable_block = false;
        if (res.error === false) {
          this.toastr.success("Khóa tem thành công", "Thông báo", {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
          this.blockModal.hide();
          return;
        }
        this.toastr.success(res.message, "Khóa tem thất bại", {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
      },
      (error) => {
        this.disable_block = false;
        this.toastr.error(error.message, "Khóa tem thất bại", {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
      }
    );
  }

  // xoa tem khoi thung
  openModalRemoveStamp() {
    this.remove.show();
  }

  closeModalRemoveStamp() {
    this.remove.hide();
  }

  submitModalRemoveStamp() {
    if (this.type === "mul") {
      if (this.data_remove.length === 0) {
        this.toastr.error("Chưa chọn tem cần xóa", "Có lỗi xảy ra", {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
        return;
      }
      this.disable_remove = true;
      const box_id = this.data.bundleId;
      let listRemove = this.data_remove.map((gg) =>
        this.data_stamp_of_box.find((it) => it.id == gg)
      );
      let body = listRemove.map((list) => {
        return {
          id: list.id,
          bundleType: list.bundleType,
        };
      });
      this.checkStampService.deleteStampOfbox(box_id, body).subscribe(
        (res) => {
          this.disable_remove = false;
          if (res.code === 1) {
            this.toastr.success(
              "Xóa dải tem khỏi thùng thành công",
              "Thành công",
              {
                timeOut: 4000,
                positionClass: "toast-top-right",
              }
            );
            this.isCheckAll = false;
            this.list_id = [];
            this.listOfChecked = {};
            this.type = undefined;
            this.data_remove = [];
            this.loadStampOfBox();
            this.closeModalRemoveStamp();
            return;
          }
          this.toastr.error(res.message, "Xóa dải tem thất bại");
        },
        (error) => {
          this.disable_remove = false;
          this.toastr.error(error.message, "Xóa dải tem thất bại");
        }
      );
      return;
    }
    // const ids = this.data_remove.toString();
    const box_id = this.data.bundleId;
    let listRemove = this.data_remove.map((gg) =>
      this.data_stamp_of_box.find((it) => it.id == gg)
    );
    let body = listRemove.map((list) => {
      return {
        id: list.id,
        bundleType: list.bundleType,
      };
    });
    console.log(box_id, body);
    this.disable_remove = true;
    this.checkStampService.deleteStampOfbox(box_id, body).subscribe(
      (res) => {
        this.disable_remove = false;
        if (res.code === 1) {
          this.toastr.success(
            "Xóa dải tem khỏi thùng thành công",
            "Thành công",
            {
              timeOut: 4000,
              positionClass: "toast-top-right",
            }
          );
          this.isCheckAll = false;
          this.list_id = [];
          this.listOfChecked = {};
          this.type = undefined;
          this.data_remove = [];
          this.loadStampOfBox();
          this.closeModalRemoveStamp();
          return;
        }
        this.toastr.error(res.message, "Xóa dải tem thất bại");
      },
      (error) => {
        this.disable_remove = false;
        this.toastr.error(error.message, "Xóa dải tem thất bại");
      }
    );
  }

  removeStamp(type: string, data?: any) {
    this.type = type;
    this.data_remove = data;
    if (type === "mul") {
      const value = $("#actions").val();
      if (value) {
        this.openModalRemoveStamp();
      }
      return;
    }
    this.openModalRemoveStamp();
  }

  checkALl(event) {
    this.valid_stamp_select = false;
    this.isCheckAll = event.target.checked;
    if (this.isCheckAll) {
      this.data_stamp_of_box.map((item) => {
        if (item.exclude === true) {
          this.valid_stamp_select = true;
          this.toastr.error(
            "Không thể chọn dải tem đã bị tách phân phối lẻ",
            "Có lỗi xảy ra",
            {
              timeOut: 4000,
              positionClass: "toast-top-right",
            }
          );
        }
        this.listOfChecked[item.id] = true;
      });
      this.listIdChecked();
      this.data_stamp_of_box.map((item) => {
        this.data_checked.push(item);
      });
      return;
    }
    this.data_checked = [];
    this.data_stamp_of_box.map((item) => {
      this.listOfChecked[item.id] = false;
      this.listIdChecked();
    });
  }

  async checkBoxChange(event) {
    const checked = event.target.checked;
    const value = event.target.value;
    if (checked === true) {
      this.data_stamp_of_box.map((item) => {
        if (item.id === value) {
          this.data_checked.push(item);
          if (item.exclude === true) {
            this.valid_stamp_select = true;
            this.toastr.error(
              "Không thể chọn dải tem đã bị tách phân phối lẻ",
              "Có lỗi xảy ra",
              {
                timeOut: 4000,
                positionClass: "toast-top-right",
              }
            );
          }
        }
      });
    }
    if (checked === false) {
      this.data_stamp_of_box.map((item) => {
        if (item.id === value) {
          const index = this.data_checked.indexOf(item);
          if (index > -1) {
            this.data_checked.splice(index, 1);
          }
        }
      });
    }
    const list = [];
    await this.data_checked.map((item) => {
      if (item.exclude === true) {
        list.push(item);
      }
    });
    this.valid_stamp_select = list.length !== 0;
    this.listOfChecked[value] = checked;
    this.isCheckAll = this.data_stamp_of_box.every(
      (item) => this.listOfChecked[item.id]
    );
    this.listIdChecked();
  }

  refeshCheckAll() {
    if (this.data_stamp_of_box && this.data_stamp_of_box.length) {
      this.isCheckAll = this.data_stamp_of_box.every(
        (item) => this.listOfChecked[item.id]
      );
      return;
    }
    this.isCheckAll = false;
  }

  listIdChecked() {
    for (const key in this.listOfChecked) {
      console.log(this.listOfChecked);
      if (this.listOfChecked[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }

  // ================ thu hoi tem =================== //
  openModalRevoke() {
    this.revoke.show();
  }

  closeModalRevoke() {
    this.revoke.hide();
  }

  submitModalRevoke() {
    const body = {
      datas: [
        {
          bundleId: this.data.bundleId,
        },
      ],
    };

    this.disable_revoke = true;
    this.checkStampService.takeBackStamp(body).subscribe(
      (res) => {
        this.disable_revoke = false;
        if (res.code === 1) {
          this.toastr.success("Thu hồi tem thành công", "Thành công", {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
          return;
        }
        this.toastr.error(res.message, "Thu hồi tem thất bại");
      },
      (error) => {
        this.disable_revoke = false;
        this.toastr.error(error.message, "Thu hồi tem thất bại");
      }
    );
  }

  // ================ phan phoi =================== //

  changeDistribution() {
    this.isDistribution = true;
    this.isList = false;
    this.boxStampDistribution.setData(
      this.data.serial,
      this.data.bundleType,
      true
    );
  }

  hideComponentDistribuiton(event) {
    this.isDistribution = false;
    this.isList = true;
  }

  getAllHistoryDistribution() {
    const body = {
      page: 1,
      serial: this.data.serial,
      page_size: this.total_distribution,
      owner: this.data.owner,
    };
    this.data_map = [];
    this.checkStampService.getStampHistory(body).subscribe((res) => {
      if (res.code === 1) {
        const items = res.data.items;
        const data = [];
        for (let i = items.length - 1; i >= 0; i--) {
          data.push(items[i]);
        }
        this.getMapFromLatLng(data);
      }
    });
  }

  getMapFromLatLng(data?: any[]) {
    data.map(async (item, index) => {
      const type = [];
      if (item.userScanWarning) {
        type.push(0);
      }
      if (item.warning) {
        type.push(1);
      }
      let color;
      switch (item.transferType) {
        case 0: {
          color = "blue";
          break;
        }
        case 1: {
          color = "#f00";
          break;
        }
        case 2: {
          color = "#BDBDBD";
          break;
        }
      }
      const object = {
        origin: undefined,
        destination: undefined,
        renderOptions: undefined,
      };
      if (item.transferType === 1 || item.transferType === 2) {
        object.renderOptions = {
          polylineOptions: { strokeColor: `${color}`, strokeWeight: 5 },
        };
      }
      // tslint:disable-next-line:max-line-length
      const address_from =
        (item.fromAddress !== null ? item.fromAddress : "") +
        " " +
        (item.fromDistrict !== null ? item.fromDistrict : "") +
        " " +
        (item.fromProvince !== null ? item.fromProvince : "");
      const query_from = {
        input: address_from,
        api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
      };
      const obj_from = item.fromLocation;
      this.lng = obj_from.lng;
      this.lat = obj_from.lat;
      object.origin = obj_from;
      console.log(33333, object.origin)
      // await this.getPlaceId(query_from).then((place_id_from) => {
      //   if (place_id_from.status === "OK") {
      //     const place_id = place_id_from.predictions[0].place_id;
      //     this.getLatLon(place_id).then((latlon_from) => {
      //       if (latlon_from.status === "OK") {
      //         const obj_from = {
      //           lat: latlon_from.result.geometry.location.lat,
      //           lng: latlon_from.result.geometry.location.lng,
      //         };
      //         this.lng = latlon_from.result.geometry.location.lng;
      //         this.lat = latlon_from.result.geometry.location.lat;
      //         object.origin = obj_from;
      //       }
      //     });
      //   }
      // });
      // get Lat lon theo dia chi
      if (
        item.toProvince !== null ||
        item.toDistrict !== null ||
        item.toAddress !== null
      ) {
        // tslint:disable-next-line:max-line-length
        const address_to =
          (item.toAddress !== null ? item.toAddress : "") +
          " " +
          (item.toDistrict !== null ? item.toDistrict : "") +
          " " +
          (item.toProvince !== null ? item.toProvince : "");
        const query_to = {
          input: address_to,
          api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
        };
        const obj = item.toLocation;

        const a = {
          origin: object.origin,
          destination: obj,
          renderOptions: object.renderOptions,
        };
        this.data_map.push(a);
        const market = {
          lat: obj.lat,
          lng: obj.lng,
          label: `${item.toProvince},${item.toAddress}`,
          icon: {
            url: undefined,
            scaledSize: {
              height: 30,
              width: 30,
            },
          },
          type: [],
          agency: undefined,
        };
        market.agency = item.toAgency !== null ? item.toAgency.trim() : '';
        if (type.length === 1) {
          type.map((item_type) => {
            // tslint:disable-next-line:radix
            if (parseInt(item_type) === 0) {
              market.icon.url =
                'https://image.flaticon.com/icons/svg/1277/1277612.svg';
              market.type = [0];
            }
            // tslint:disable-next-line:radix
            if (parseInt(item_type) === 1) {
              market.icon.url =
                'https://image.flaticon.com/icons/svg/3325/3325026.svg';
              market.type = [1];
            }
            this.data_map_warning.push(market);
          });
        }
        if (type.length === 2) {
          if (type.includes(0) && type.includes(1)) {
            market.icon.url =
              'https://image.flaticon.com/icons/svg/1277/1277612.svg';
            market.type = [0, 1];
          }
          this.data_map_warning.push(market);
        }
        // this.getPlaceId(query_to).then((place_id_data) => {
        //   if (place_id_data.status === "OK") {
        //     const place_id = place_id_data.predictions[0].place_id;
        //     this.getLatLon(place_id).then((latlon_to_case_one_province) => {
        //       if (latlon_to_case_one_province.status === "OK") {
        //         const obj = {
        //           lat: latlon_to_case_one_province.result.geometry.location.lat,
        //           lng: latlon_to_case_one_province.result.geometry.location.lng,
        //         };
        //         const a = {
        //           origin: object.origin,
        //           destination: obj,
        //           renderOptions: object.renderOptions,
        //         };
        //         this.data_map.push(a);
        //         const market = {
        //           lat: latlon_to_case_one_province.result.geometry.location.lat,
        //           lng: latlon_to_case_one_province.result.geometry.location.lng,
        //           label: `${latlon_to_case_one_province.result.name},${latlon_to_case_one_province.result.formatted_address}`,
        //           icon: {
        //             url: undefined,
        //             scaledSize: {
        //               height: 30,
        //               width: 30,
        //             },
        //           },
        //           type: [],
        //           agency: undefined,
        //         };
        //         market.agency =
        //           item.toAgency !== null ? item.toAgency.trim() : "";
        //         if (type.length === 1) {
        //           type.map((item_type) => {
        //             // tslint:disable-next-line:radix
        //             if (parseInt(item_type) === 0) {
        //               market.icon.url =
        //                 "https://image.flaticon.com/icons/svg/1277/1277612.svg";
        //               market.type = [0];
        //             }
        //             // tslint:disable-next-line:radix
        //             if (parseInt(item_type) === 1) {
        //               market.icon.url =
        //                 "https://image.flaticon.com/icons/svg/3325/3325026.svg";
        //               market.type = [1];
        //             }
        //             this.data_map_warning.push(market);
        //           });
        //         }
        //         if (type.length === 2) {
        //           if (type.includes(0) && type.includes(1)) {
        //             market.icon.url =
        //               "https://image.flaticon.com/icons/svg/1277/1277612.svg";
        //             market.type = [0, 1];
        //           }
        //           this.data_map_warning.push(market);
        //         }
        //       }
        //     });
        //   }
        // });
        return;
      }
      // get lat lon theo id
      const locationTo = item.location.item;
      const provinces = locationTo.provinceIds;
      const arr = [];
      // case 1 tinh
      // if (provinces.length === 1) {
      //   const provinceId = provinces[0];
      //   let provinceName = "";
      //   this.cities.map((city) => {
      //     if (city.id === provinceId) {
      //       provinceName = city.value;
      //     }
      //   });
      //   let district_list = [];
      //   await this.getDistrictMap(provinceId).then((district) => {
      //     if (district.error === false) {
      //       district_list = district.data.districts;
      //     }
      //   });
      //   let locationToConverted = [];
      //   const districts_to = locationTo.districtIds;
      //   if (districts_to.length > 0) {
      //     const districts_to_name = [];
      //     if (districts_to.length) {
      //       districts_to.map((d) => {
      //         district_list.map((di) => {
      //           if (di.id === d) {
      //             districts_to_name.push(di.name);
      //           }
      //         });
      //       });
      //     }
      //     districts_to_name.map((i) => {
      //       const location = `${i} ${provinceName}`;
      //       locationToConverted.push(location);
      //     });
      //     if (locationToConverted.length === 1) {
      //       locationToConverted.map((l) => {
      //         locationToConverted = [];
      //         locationToConverted = [`${locationTo.address} ${l}`];
      //       });
      //     }
      //   }
      //   if (districts_to.length === 0) {
      //     const address$ = locationTo.address;
      //     if (address$.length > 0) {
      //       locationToConverted = [`${address$[0]} ${provinceName}`];
      //     } else {
      //       locationToConverted = [`${provinceName}`];
      //     }
      //   }
        // tslint:disable-next-line:no-shadowed-variable
      let locationData = item.districtLocations.length > 0 && item.districtLocations[0].lat ?  item.districtLocations  : item.provinceLocations ;

      locationData.map((val) => {
          const obj = {
            lat: val.lat,
            lng: val.lon,
          };
          console.log(obj)
          const market = {
            lat: obj.lat,
            lng: obj.lng,
            label: `${val.name}`,
            icon: {
              url: undefined,
              scaledSize: {
                height: 30,
                width: 30,
              },
            },
            type: [],
            agency: undefined,
          };

          if (type.length === 1) {
            type.map((item_type) => {
              // tslint:disable-next-line:radix
              if (parseInt(item_type) === 0) {
                market.icon.url =
                  'https://image.flaticon.com/icons/svg/1277/1277612.svg';
                market.type = [0];
              }
              // tslint:disable-next-line:radix
              if (parseInt(item_type) === 1) {
                market.icon.url =
                  'https://image.flaticon.com/icons/svg/3325/3325026.svg';
                market.type = [1];
              }
              this.data_map_warning.push(market);
            });
          }
          if (type.length === 2) {
            if (type.includes(0) && type.includes(1)) {
              market.icon.url =
                'https://image.flaticon.com/icons/svg/1277/1277612.svg';
              market.type = [0, 1];
            }
            this.data_map_warning.push(market);
          }
          arr.push(obj)
        })
        // locationToConverted.map((l, index) => {
        //   arr.push(
        //     new Promise((resolve, reject) => {
        //       const query_to = {
        //         input: l,
        //         api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
        //       };
        //       const get_placeId_to = this.getPlaceId(query_to);
        //       get_placeId_to.then((placeId) => {
        //         if (placeId.status === "OK") {
        //           const place_id = placeId.predictions[0].place_id;
        //           this.getLatLon(place_id).then((latlon) => {
        //             if (latlon.status === "OK") {
        //               const obj = {
        //                 lat: latlon.result.geometry.location.lat,
        //                 lng: latlon.result.geometry.location.lng,
        //               };
        //               const market = {
        //                 lat: latlon.result.geometry.location.lat,
        //                 lng: latlon.result.geometry.location.lng,
        //                 label: `${latlon.result.name},${latlon.result.formatted_address}`,
        //                 icon: {
        //                   url: undefined,
        //                   scaledSize: {
        //                     height: 30,
        //                     width: 30,
        //                   },
        //                 },
        //                 type: [],
        //                 agency: undefined,
        //               };
        //               if (type.length === 1) {
        //                 type.map((item_type) => {
        //                   // tslint:disable-next-line:radix
        //                   if (parseInt(item_type) === 0) {
        //                     market.icon.url =
        //                       "https://image.flaticon.com/icons/svg/1277/1277612.svg";
        //                     market.type = [0];
        //                   }
        //                   // tslint:disable-next-line:radix
        //                   if (parseInt(item_type) === 1) {
        //                     market.icon.url =
        //                       "https://image.flaticon.com/icons/svg/3325/3325026.svg";
        //                     market.type = [1];
        //                   }
        //                   this.data_map_warning.push(market);
        //                 });
        //               }
        //               if (type.length === 2) {
        //                 if (type.includes(0) && type.includes(1)) {
        //                   market.icon.url =
        //                     "https://image.flaticon.com/icons/svg/1277/1277612.svg";
        //                   market.type = [0, 1];
        //                 }
        //                 this.data_map_warning.push(market);
        //               }
        //               resolve(obj);
        //             }
        //           });
        //         }
        //       });
        //     })
        //   );
        // });
        Promise.all(arr).then((data_finally) => {
          data_finally.map((one_data) => {
            const a = {
              origin: object.origin,
              destination: one_data,
              renderOptions: object.renderOptions,
            };
            this.data_map.push(a);
          });
        });
        return;
      // }
      // case nhieu tinh
      // const list_province_name = [];
      // await provinces.map((pro) => {
      //   this.cities.map((ci) => {
      //     if (ci.id === pro) {
      //       list_province_name.push(ci.value);
      //     }
      //   });
      // });
      // list_province_name.map((pro_name) => {
      //   arr.push(
      //     new Promise((resolve, reject) => {
      //       const query_from_case_multiple_province = {
      //         input: pro_name,
      //         api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
      //       };
      //       this.getPlaceId(query_from_case_multiple_province).then(
      //         (place_id_from) => {
      //           if (place_id_from.status === "OK") {
      //             const place_id = place_id_from.predictions[0].place_id;
      //             this.getLatLon(place_id).then((latlon) => {
      //               if (latlon.status === "OK") {
      //                 const obj = {
      //                   lat: latlon.result.geometry.location.lat,
      //                   lng: latlon.result.geometry.location.lng,
      //                 };
      //                 const market = {
      //                   lat: latlon.result.geometry.location.lat,
      //                   lng: latlon.result.geometry.location.lng,
      //                   label: `${latlon.result.name},${latlon.result.formatted_address}`,
      //                   icon: {
      //                     url: undefined,
      //                     scaledSize: {
      //                       height: 30,
      //                       width: 30,
      //                     },
      //                   },
      //                   type: [],
      //                   agency: undefined,
      //                 };
      //                 if (type.length === 1) {
      //                   type.map((item_type) => {
      //                     // tslint:disable-next-line:radix
      //                     if (parseInt(item_type) === 0) {
      //                       market.icon.url =
      //                         "https://image.flaticon.com/icons/svg/1277/1277612.svg";
      //                       market.type = [0];
      //                     }
      //                     // tslint:disable-next-line:radix
      //                     if (parseInt(item_type) === 1) {
      //                       market.icon.url =
      //                         "https://image.flaticon.com/icons/svg/3325/3325026.svg";
      //                       market.type = [1];
      //                     }
      //                     this.data_map_warning.push(market);
      //                   });
      //                 }
      //                 if (type.length === 2) {
      //                   if (type.includes(0) && type.includes(1)) {
      //                     market.icon.url =
      //                       "https://image.flaticon.com/icons/svg/1277/1277612.svg";
      //                     market.type = [0, 1];
      //                   }
      //                   this.data_map_warning.push(market);
      //                 }
      //                 resolve(obj);
      //               }
      //             });
      //           }
      //         }
      //       );
      //     })
      //   );
      // });
      // Promise.all(arr).then((data_finally) => {
      //   data_finally.map((one_data) => {
      //     const a = {
      //       origin: object.origin,
      //       destination: one_data,
      //       renderOptions: object.renderOptions,
      //     };
      //     this.data_map.push(a);
      //   });
      // });
    });
  }

  getAllWarningMarket() {
    this.warningInspection
      .getList({
        page: 1,
        page_size: !this.after_create_warning
          ? this.total_warning
          : this.total_warning + 1,
        serial: this.data.serial,
      })
      .subscribe((res) => {
        if (res.code === 1) {
          const items = res.data.items;
          const arr_promise = [];
          items.map((item, index) => {
            if (this.after_create_warning === true && index !== 0) {
              return;
            }
            arr_promise.push(
              new Promise((resolve, reject) => {
                // canh bao toi dai ly
                // tslint:disable-next-line:max-line-length
                const address =
                  (item.addressWarning !== null
                    ? item.addressWarning + " "
                    : "") +
                  (item.districtWarning !== null
                    ? item.districtWarning + " "
                    : "") +
                  (item.provinceWarning !== null ? item.provinceWarning : "");
                const query = {
                  input: address,
                  api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
                };

                const nameAgency =
                  item.agencyWarning !== null ? item.agencyWarning : '';
                const market = {
                  lat: item.location.lat,
                  lng: item.location.lng,
                  // tslint:disable-next-line:max-line-length
                  label: `${item.provinceWarning},${item.districtWarning}`,
                  icon: {
                    url:
                      'https://image.flaticon.com/icons/svg/196/196759.svg',
                    scaledSize: {
                      height: 30,
                      width: 30,
                    },
                  },
                  type: [2],
                  agency: nameAgency,
                };
                resolve(market);
                // this.getPlaceId(query).then((place) => {
                //   if (place.status === "OK") {
                //     const place_id = place.predictions[0].place_id;
                //     this.getLatLon(place_id).then(async (latlon) => {
                //       if (latlon.status === "OK") {
                //         const nameAgency =
                //           item.agencyWarning !== null ? item.agencyWarning : "";
                //         const market = {
                //           lat: latlon.result.geometry.location.lat,
                //           lng: latlon.result.geometry.location.lng,
                //           // tslint:disable-next-line:max-line-length
                //           label: `${latlon.result.name},${latlon.result.formatted_address}`,
                //           icon: {
                //             url:
                //               "https://image.flaticon.com/icons/svg/196/196759.svg",
                //             scaledSize: {
                //               height: 30,
                //               width: 30,
                //             },
                //           },
                //           type: [2],
                //           agency: nameAgency,
                //         };
                //         resolve(market);
                //       }
                //     });
                //   }
                // });
              })
            );
          });
          Promise.all(arr_promise).then((data_market) => {
            if (this.after_create_warning === false) {
              // loai bo cac điểm cảnh báo trùng nhau
              const data_market_finish = [];
              data_market.map(async (mar) => {
                if (data_market_finish.length === 0) {
                  data_market_finish.push(mar);
                  return;
                }
                let not_in = false;
                data_market_finish.map(async (i) => {
                  if (i.lat === mar.lat && i.lng === mar.lng) {
                    not_in = true;
                  }
                });
                if (!not_in) {
                  data_market_finish.push(mar);
                }
              });
              if (this.data_map_warning.length === 0) {
                data_market_finish.map((data$) => {
                  this.data_map_warning.push(data$);
                  return;
                });
              } else {
                data_market_finish.map(async (data$) => {
                  let not_in_data_warning = false;
                  this.data_map_warning.map(async (i_of_data) => {
                    if (
                      i_of_data.lat === data$.lat &&
                      i_of_data.lng === data$.lng
                    ) {
                      not_in_data_warning = true;
                    }
                  });
                  if (!not_in_data_warning) {
                    await this.data_map_warning.push(data$);
                  } else {
                    this.data_map_warning.map((item_duplicate) => {
                      if (
                        item_duplicate.lat === data$.lat &&
                        item_duplicate.lng === data$.lng &&
                        !item_duplicate.type.includes(2)
                      ) {
                        item_duplicate.type.push(2);
                        if (item_duplicate.agency !== data$.agency) {
                          item_duplicate.agency = `${item_duplicate.agency},${data$.agency}`;
                        }
                      }
                    });
                  }
                });
              }
              this.data_map_warning.map((item_convert) => {
                let label = "";
                const typeOfMarket = item_convert.type;
                if (typeOfMarket.length === 1) {
                  if (typeOfMarket.includes(0)) {
                    label = "Địa điểm bị cảnh báo từ người dùng";
                  }
                  if (typeOfMarket.includes(1)) {
                    label = "Địa điểm bị cảnh báo tự động";
                  }
                  if (typeOfMarket.includes(2)) {
                    label = "Địa điểm bị cảnh báo từ kiểm tra thị trường";
                  }
                }
                if (typeOfMarket.length === 2) {
                  if (typeOfMarket.includes(0) && typeOfMarket.includes(1)) {
                    label = "Địa điểm bị cảnh báo từ người dùng và tự động";
                  }
                  if (typeOfMarket.includes(0) && typeOfMarket.includes(2)) {
                    label =
                      "Địa điểm bị cảnh báo từ người dùng và kiểm tra thị trường";
                  }
                  if (typeOfMarket.includes(1) && typeOfMarket.includes(2)) {
                    label =
                      "Địa điểm bị cảnh báo tự động và kiểm tra thị trường";
                  }
                }
                if (typeOfMarket.length === 3) {
                  label =
                    "Địa điểm bị cảnh báo từ người dùng,tự động và kiểm tra thị trường";
                }
                if (item_convert.agency) {
                  const to_agency = `${item_convert.agency}.Địa chỉ:`;
                  item_convert.label = `${label}:${to_agency}${item_convert.label} `;
                } else {
                  item_convert.label = `${label}.Địa chỉ:${item_convert.label} `;
                }
              });
              return;
            }
            if (this.after_create_warning === true) {
              data_market.map((one_data_market) => {
                let label$ = "";
                if (one_data_market.agency) {
                  label$ = `Địa điểm bị cảnh báo từ kiểm tra thị trường:${one_data_market.agency}.Địa chỉ:${one_data_market.label}`;
                } else {
                  label$ = `Địa điểm bị cảnh báo từ kiểm tra thị trường.Địa chỉ:${one_data_market.label}`;
                }
                one_data_market.label = label$;
                this.data_map_warning.push(one_data_market);
              });
            }
          });
          return;
        }
      });
  }

  // getPlaceId(query?: any) {
  //   return this.checkStampService.getPalceId(query).toPromise();
  // }
  //
  // getLatLon(place_id?: string) {
  //   const query = {
  //     placeid: place_id,
  //     api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
  //   };
  //   return this.checkStampService.getLatLon(query).toPromise();
  // }

  async getDistrictMap(id: number) {
    const query = {
      city_id: id,
    };
    return await this.addressService.getDistrict(query).toPromise();
  }

  typeStampModal: any = "";
  showModalDetailStatus(type?: string, data?: any) {
    this.data_detail = data;
    this.typeStampModal = type;
    this.data_detail.map((i) => {
      const pad = "000000";
      i.idEnd =
        pad.substring(0, pad.length - i.idEnd.toString().length) + i.idEnd;
      i.idStart =
        pad.substring(0, pad.length - i.idStart.toString().length) + i.idStart;
    });
    if (type === "distributedChildren") {
      this.type_status = "Danh sách tem đã phân phối";
    }
    if (type === "childrenReturned") {
      this.type_status = "Danh sách tem đã bị trả hàng";
    }
    if (type === "takeBackChildren") {
      this.type_status = "Danh sách tem đã thu hồi";
    }
    if (type === "returnedParent") {
      this.type_status = "Danh sách tem đã trả hàng";
    }
    if (type === "takeBackParent") {
      this.type_status = "Danh sách tem đã bị thu hồi";
    }
  }

  // show modal đóng thùng
  showCratingBoxModal() {}
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp_list/stamp-box/stamp-box.component.ts